import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * CheckRouter - Kiểm tra quyền truy cập của user vào route dựa trên key_menu (permKey)
 * Nếu không có quyền sẽ redirect về trang thông tin tài khoản
 */
const FULL_ACCESS_ROLES = [1, 9999];

const CheckRouter = ({ children, permKey }) => {
  const dataRedux = useSelector((state) => state.user);
  const userPermissions = (dataRedux?.info?.permissions || []).map((item) => item.key_menu);
  const isFullAccess = FULL_ACCESS_ROLES.includes(dataRedux?.info?.role);

  // Full quyền hoặc không yêu cầu permKey (như /info) -> cho qua
  if (isFullAccess || !permKey) {
    return children;
  }

  // So khớp permKey với danh sách key_menu trong permissions của user
  const hasPerm = Array.isArray(permKey)
    ? permKey.some((k) => userPermissions.includes(k))
    : userPermissions.includes(permKey);

  if (hasPerm) {
    return children;
  }

  // Không có quyền -> Về info
  return <Navigate to="/info" replace />;
};

export default CheckRouter;
